import { render } from "./JournalsFilters.vue?vue&type=template&id=39cfd17e&scoped=true"
import script from "./JournalsFilters.vue?vue&type=script&lang=js"
export * from "./JournalsFilters.vue?vue&type=script&lang=js"

import "./JournalsFilters.vue?vue&type=style&index=0&id=39cfd17e&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cfd17e"]])

export default __exports__